var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 9.43935L12.1819 12.6213L11.1213 13.6819L9.75 12.3113V16.5H8.25V12.3097L6.87868 13.6819L5.81802 12.6213L9 9.43935ZM9 1.5C11.6951 1.5 13.9158 3.53071 14.2156 6.14546C15.9643 6.62365 17.25 8.2242 17.25 10.125C17.25 12.2766 15.6027 14.0435 13.5005 14.2332L13.5007 12.7233C14.7725 12.541 15.75 11.4472 15.75 10.125C15.75 8.67525 14.5747 7.5 13.125 7.5C12.9684 7.5 12.815 7.51372 12.6665 7.5405C12.7212 7.28565 12.75 7.02118 12.75 6.75C12.75 4.67894 11.071 3 9 3C6.92894 3 5.25 4.67894 5.25 6.75C5.25 7.02118 5.27879 7.28565 5.33404 7.53998C5.18498 7.51372 5.03159 7.5 4.875 7.5C3.42525 7.5 2.25 8.67525 2.25 10.125C2.25 11.4002 3.15931 12.463 4.36489 12.7005L4.50004 12.7234L4.50029 14.2332C2.39772 14.0439 0.75 12.2769 0.75 10.125C0.75 8.2242 2.03568 6.62365 3.78486 6.14558C4.08421 3.53071 6.30496 1.5 9 1.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c90d6d90b46cce4c86fba7702126c94d.svg";
export { ForwardRef as ReactComponent };